import clsx from "clsx";
import { formattedArea, useTranslation } from "react-migration/lib";
import { getMeasurementSystemPreference } from "src/js/stores/user/actions";

export interface CompsCalculatorErrorMessageProps {
  className?: string;
  drawing?: unknown;
  show?: boolean;
}

export function ComparablesCalculatorErrorMessage({
  className,
  drawing,
  show,
}: Readonly<CompsCalculatorErrorMessageProps>) {
  const unitPreference = getMeasurementSystemPreference();
  const { t } = useTranslation();
  return (
    <div
      className={clsx(
        `atlas-overflow-hidden atlas-flex atlas-items-center atlas-h atlas-duration-500 atlas-px-3 atlas-bg-background-negative-subtle atlas-border-border-negative-subtle atlas-rounded-md atlas-text-content-negative`,
        show ? "atlas-h-16 atlas-py-2" : "atlas-h-0 atlas-py-0",
        className
      )}
    >
      {t(
        drawing
          ? "comparables.calculator.hometrack_search_shape_too_large"
          : "comparables.calculator.hometrack_search_viewport_too_large"
      )}{" "}
      {formattedArea({ area: 30000000, unitPreference, t, granularity: "large" })},{" "}
      {t(
        drawing ? "comparables.calculator.revise_selection" : "comparables.calculator.zoom_or_draw"
      )}
    </div>
  );
}
